export var URL_SIZES = {
    RESIZED: 'resized',
    PIXEL: 'pixel',
    THUMBNAIL: 'thumbnail',
    SQUARE: 'square',
    FULL: 'full',
    SAMPLE: 'sample',
    PRELOAD: 'preload',
    DOWNLOAD: 'download',
    DOWNLOAD_SAMPLE: 'download_sample',
};
export var URL_TYPES = {
    HIGH_RES: 'img',
    LOW_RES: 'thumb',
    SEO: 'seoLink',
    VIDEO: 'video',
};
//# sourceMappingURL=urlTypes.js.map